// Search box -> key terms become Nimstrata URL filters (see the "Search Fix Plan" doc).
// Reads assets/search-terms.json. Never blocks a search: no term list yet, or no key terms -> the search submits unchanged.
(function () {
  var TERMS_URL = window.BCS_SEARCH_TERMS_URL; // set in theme.liquid from {{ 'search-terms.json' | asset_url }}
  var CACHE_KEY = 'bcs-search-terms', TTL_MS = 60 * 60 * 1000;
  // Every flag word becomes its own attributes.attributes value in the URL. Nimstrata's page ORs repeats of
  // one filter, so the RCC fetch patch in layout/theme.liquid splits them into separate filters (all must match).
  var FLAG_ORDER = ['rpa', 'rookie', 'autograph', 'numbered'];
  var FLAG_VALUE = { rpa: 'RPA', rookie: 'Rookie', autograph: 'Autograph', numbered: 'Serial Number' };
  var MAX_PHRASE = 6;
  var CITY_ALIAS = { la: 'los angeles', ny: 'new york', nyc: 'new york', kc: 'kansas city', sf: 'san francisco', tb: 'tampa bay' };
  var terms = null;

  // Must match the "normalize" rule in search-terms.json.
  function norm(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/(\d)\.(\d)/g, '$1․$2').replace(/[.'’]/g, '').replace(/․/g, '.')
      .replace(/[^a-z0-9\/.]+/g, ' ').trim();
  }

  function useTerms(t) {
    terms = t;
    terms.protectSet = new Set(t.protect || []);
    terms.stopSet = new Set(t.stoplist || []);
    terms.gradedSet = new Set((t.graded && t.graded.words) || []);
    terms.gradeSet = new Set(t.grades || []);
    terms.graders = t.graders || {};
    terms.yearSet = new Set(t.years || []);
    // City -> every team value containing it as whole words: "boston" -> Red Sox, Celtics, Bruins, Braves, Boston College.
    var values = [];
    Object.keys(t.teams).forEach(function (k) { t.teams[k].forEach(function (v) { if (values.indexOf(v) === -1) values.push(v); }); });
    terms.cityTeams = {};
    (t.cities || []).forEach(function (c) {
      var names = [c].concat(CITY_ALIAS[c] || []); // "la" also means every "los angeles" team
      var hits = values.filter(function (v) {
        return names.some(function (n) { return (' ' + norm(v) + ' ').indexOf(' ' + n + ' ') !== -1; });
      });
      if (hits.length) terms.cityTeams[c] = hits;
    });
  }

  // Season years mean their first year: "2024-25", "24-25" and "2024-2025" -> "2024" ("91-92" -> 1991 when 2091 isn't a stocked year).
  // Only consecutive pairs, so card-number ranges like "#13-25" are left alone.
  function seasonYears(query) {
    return query.replace(/(^|[^\d#\/])(\d{2}|\d{4})\s*-\s*(\d{2}|\d{4})(?!\d)/g, function (m, pre, a, b) {
      if ((+a.slice(-2) + 1) % 100 !== +b.slice(-2)) return m;
      return pre + (a.length === 4 ? a : terms.yearSet.has('20' + a) ? '20' + a : '19' + a);
    });
  }

  function load() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.url === TERMS_URL && Date.now() - cached.at < TTL_MS) return useTerms(cached.terms);
    } catch (e) {}
    if (!TERMS_URL) return;
    fetch(TERMS_URL).then(function (r) { return r.ok ? r.json() : null; }).then(function (t) {
      if (!t || !t.teams) return;
      useTerms(t);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), url: TERMS_URL, terms: t })); } catch (e) {}
    }).catch(function () {});
  }

  // Longest phrase first, whole words only: "new york knicks" beats "knicks"; "marcano" never matches "rc".
  function parse(query, noNames) {
    var words = norm(seasonYears(query)).split(' ').filter(Boolean);
    var teams = [], city = null, flags = {}, kept = [], grading = [], grade = null, years = [];
    for (var i = 0; i < words.length;) {
      var hit = null;
      for (var n = Math.min(MAX_PHRASE, words.length - i); n > 0 && !hit; n--) {
        var phrase = words.slice(i, i + n).join(' ');
        if (terms.protectSet.has(phrase)) hit = { n: n, keep: phrase };
        else if (terms.teams[phrase] && !terms.stopSet.has(phrase)) hit = { n: n, teams: terms.teams[phrase] };
        else if (terms.cityTeams[phrase]) hit = { n: n, city: phrase };
        else if (terms.flags[phrase]) hit = { n: n, flag: terms.flags[phrase], phrase: phrase };
        else if (terms.graders[phrase]) hit = { n: n, grader: terms.graders[phrase] };
        else if (terms.gradedSet.has(phrase)) hit = { n: n, graded: true };
      }
      if (!hit && terms.yearSet.has(words[i])) { years.push(words[i]); i += 1; continue; } // a year we stock; others stay words
      if (!hit) { kept.push(words[i]); i += 1; continue; }
      if (hit.keep) kept.push(hit.keep);
      else if (hit.teams) teams = teams.concat(hit.teams);
      else if (hit.city) city = city || hit.city;
      else if (hit.flag) { if (!flags[hit.flag]) flags[hit.flag] = hit.phrase; }
      else if (hit.grader) {
        grading = [hit.grader];
        if (terms.gradeSet.has(words[i + hit.n])) { grade = words[i + hit.n]; i += 1; } // "psa 10": the grade is the next word only
      } else if (hit.graded && !grading.length) grading = terms.graded.values;
      i += hit.n;
    }
    var flagList = FLAG_ORDER.filter(function (f) { return flags[f]; });
    // A city scopes to all its teams only when no specific team was named ("red sox boston" stays Red Sox).
    if (teams.length) city = null;
    // With a team matched, city words only hurt ("new york brunson" + Knicks filter = 0 results).
    var rest = kept.join(' ');
    if (teams.length) {
      terms.cities.slice().sort(function (a, b) { return b.length - a.length; }).forEach(function (c) {
        rest = (' ' + rest + ' ').split(' ' + c + ' ').join(' ').trim();
      });
    }
    // A last name only one player has gets their first name ("mantle" -> "mickey mantle"); go() keeps it only if that finds more.
    var words = rest.split(/\s+/).filter(Boolean), named = false;
    if (!noNames && terms.lastnames) words = words.map(function (w, i) {
      var f = terms.lastnames[w];
      if (!f || words.slice(Math.max(0, i - f.split(' ').length), i).join(' ') === f) return w; // already "mickey mantle"
      named = true;
      return f + ' ' + w;
    });
    return {
      teams: teams.filter(function (t, i, a) { return a.indexOf(t) === i; }),
      flags: flagList, grading: grading, grade: grade, rest: words.join(' '), named: named, city: city,
      years: years.filter(function (y, i, a) { return a.indexOf(y) === i; }),
    };
  }

  function buildUrl(query, noNames) {
    if (!terms) return null;
    var p = parse(query, noNames);
    // A year alone ("1954") stays a plain text search.
    if (!p.teams.length && !p.flags.length && !p.grading.length && !(p.years.length && p.rest) && !p.named && !p.city) return null;
    var params = new URLSearchParams();
    p.teams.forEach(function (t) { params.append('attributes.team', t); });
    if (p.city) params.set('city', p.city); // no chips: the doc-head-core fetch wrapper turns it into a team filter on the request
    p.flags.forEach(function (f) { params.append('attributes.attributes', FLAG_VALUE[f]); }); // all must match (theme.liquid patch)
    p.grading.forEach(function (g) { params.append('attributes.grading', g); }); // several graders = OR, which is what "graded" means
    if (p.grade) params.append('attributes.grade', p.grade);
    p.years.forEach(function (y) { params.append('attributes.waxyear', y); }); // two years = OR
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id', preview); // keep testing on the duplicate theme
    params.set('typed', query); // what the shopper typed: shown back to them in place of the rewritten search
    // Only key terms typed: an empty q is a blank /search page, so q keeps the typed words and filtersonly=1 tells the
    // doc-head-core fetch wrapper to send an empty text query (filters alone pick the cards).
    if (!p.rest) params.set('filtersonly', '1');
    params.set('q', p.rest || query);
    return '/search?' + params;
  }

  // Zero results with key-term filters: drop the filters and search the leftover words (or the shopper's own words when
  // only key terms were typed). One hop only: a fallback page (fallback=1) never falls back again.
  function fallbackUrl(search) {
    var url = new URLSearchParams(search), typed = url.get('typed');
    if (!typed || url.has('fallback')) return null;
    var params = new URLSearchParams({ q: url.get('q') || typed, typed: typed, fallback: '1' });
    var preview = url.get('preview_theme_id');
    if (preview) params.set('preview_theme_id', preview);
    return '/search?' + params;
  }

  // The parsed key terms as a Nimstrata request filter: same fields as the URL, flags as separate (all-must-match) filters.
  function filtersOf(p) {
    var f = [];
    if (p.teams.length) f.push({ field: 'attributes.team', value: p.teams });
    if (p.city) f.push({ field: 'attributes.team', value: terms.cityTeams[p.city] });
    p.flags.forEach(function (x) { f.push({ field: 'attributes.attributes', value: [FLAG_VALUE[x]] }); });
    if (p.grading.length) f.push({ field: 'attributes.grading', value: p.grading });
    if (p.grade) f.push({ field: 'attributes.grade', value: [p.grade] });
    if (p.years.length) f.push({ field: 'attributes.waxyear', value: p.years });
    return f;
  }

  // Count the filtered search before leaving the page, so a search that would find nothing goes straight to the
  // unfiltered fallback (no empty page, no redirect). Never blocks: on error or after 1.5s it opens the filtered URL.
  // Returns false when there are no key terms (the search goes through untouched).
  var PLACEMENT = 'projects/nimstrataburbank/locations/global/catalogs/default_catalog/placements/default_search';
  function count(p) {
    return fetch('https://storefront.retailconnect.app/v1/search', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ languageCode: 'en', query: p.rest, pageSize: 1, visitorId: 'bcs-precheck', eventTracking: false,
        queryExpansion: false, placement: PLACEMENT, filters: filtersOf(p) }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { var v = j && (j.value || j); return v && v.pagination && v.pagination.totalSize; });
  }

  // The shopper's own words, marked typed= so rewriteLandedSearch leaves them alone.
  function plainUrl(query) {
    var params = new URLSearchParams({ q: query, typed: query }), preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id', preview);
    return '/search?' + params;
  }

  function go(query, navigate) {
    var url = buildUrl(query);
    if (!url) return false;
    var p = parse(query), done = false;
    function finish(to) { if (!done) { done = true; navigate(to); } }
    setTimeout(function () { finish(url); }, 1500);
    // With a last name filled in, count both: "mantle" alone finds 3 but "mickey mantle" 31, yet "ohtani" alone beats "shohei ohtani".
    var bare = p.named && parse(query, true);
    Promise.all([count(p), bare && count(bare)]).then(function (n) {
      var pick = p, to = url, total = n[0];
      if (bare && n[1] >= n[0]) { pick = bare; to = buildUrl(query, true) || plainUrl(query); total = n[1]; }
      finish(total === 0 && filtersOf(pick).length ? fallbackUrl(to.slice(to.indexOf('?'))) : to);
    }).catch(function () { finish(url); });
    return true;
  }

  // On a rewritten results page: show the shopper's own words (the applied filters stay visible as Nimstrata's
  // removable chips, e.g. "Grading Company: PSA", "Grade: 10"). On a fallback page, say why the filters are gone.
  function presentTypedSearch() {
    var url = new URLSearchParams(location.search), typed = url.get('typed'), q = url.get('q');
    if (!typed) return;
    var fallback = url.has('fallback');
    if (fallback && !document.getElementById('bcs-fallback-style')) {
      var st = document.createElement('style');
      st.id = 'bcs-fallback-style'; // ponytail: theme breakpoint (theme.mediaQueries.md is min-width 768px)
      st.textContent = '#bcs-fallback-note{margin:0 0 12px;text-align:center;font-weight:400;text-wrap:balance}'
        + '#bcs-fallback-note strong{font-weight:700}#bcs-fallback-note br{display:none}'
        + '@media (max-width:767.98px){#bcs-fallback-note{padding-bottom:12px;border-bottom:1px solid rgba(127,127,127,.3)}'
        + '#bcs-fallback-note br{display:inline}}'; // phones: each sentence on its own line
      document.head.appendChild(st);
    }
    function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function apply() {
      document.querySelectorAll('input.main-search__input').forEach(function (i) {
        if (i.value !== typed && document.activeElement !== i) i.value = typed;
      });
      if (!fallback && q && document.title.indexOf('"' + q + '"') !== -1) document.title = document.title.replace('"' + q + '"', '"' + typed + '"');
      // Right above the cards (under the "N products" toolbar). Nimstrata re-renders this area, so re-place if moved.
      var grid = fallback && document.querySelector('.rcc-search__main .rcc-search__grid');
      var note = document.getElementById('bcs-fallback-note');
      if (grid && (!note || note.nextElementSibling !== grid)) {
        if (!note) {
          note = document.createElement('p');
          note.id = 'bcs-fallback-note';
          note.innerHTML = 'No filtered results for “' + esc(typed) + '”. <br><strong>Showing results for ' + esc(q || typed) + ' instead.</strong>';
        }
        grid.parentNode.insertBefore(note, grid);
      }
    }
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  // Catch-all for entry points that skip the form submit (Nimstrata's search dialog, links, pasted URLs):
  // a /search page with key terms in ?q= and no ?typed= is swapped for the filtered URL.
  function rewriteLandedSearch() {
    if (location.pathname.replace(/\/$/, '') !== '/search') return;
    var url = new URLSearchParams(location.search);
    if (url.has('typed') || !url.get('q')) return;
    go(url.get('q').replace(/"/g, ' ').replace(/\s+/g, ' ').trim(), function (to) { location.replace(to); });
  }

  load();
  if (terms) rewriteLandedSearch();
  else if (TERMS_URL) fetch(TERMS_URL).then(function (r) { return r.ok ? r.json() : null; })
    .then(function (t) { if (t && t.teams) { useTerms(t); rewriteLandedSearch(); } }).catch(function () {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', presentTypedSearch);
  else presentTypedSearch();
  window.BCSSearchKeyTerms = { buildUrl: buildUrl, fallbackUrl: fallbackUrl, filtersOf: function (q) { return terms && filtersOf(parse(q)); },
    cityTeams: function (c) { return terms && terms.cityTeams[c]; }, // used by the doc-head-core fetch wrapper
    go: go, parse: function (q, noNames) { return terms && parse(q, noNames); } }; // for console checks

  document.addEventListener('submit', function (evt) {
    var form = evt.target, input = form.querySelector && form.querySelector('input[name="q"]');
    if (!input || !/\/search/.test(form.getAttribute('action') || '')) return;
    if (!terms || !go(input.value.trim(), function (to) { location.assign(to); })) return;
    evt.preventDefault();
  }, true);
})();
